// Worker page section: queue overview per lane. Read-only.
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeaderCell,
  TableRow,
} from '@heyroot/ui/primitives/Table';
import { PERMS } from '../../../../rbac/permissions';
import { useWorkerQueue } from '../../../lib/worker-api';
import type { WorkerSectionWeb } from '../sections';
import { QueryState, SectionHeading, fmtAge } from '../worker-ui';

function QueueSection() {
  const q = useWorkerQueue();
  const lanes = q.data?.lanes ?? [];
  return (
    <section className="flex flex-col gap-3" aria-label="Queue">
      <SectionHeading
        title="Queue"
        description="Due and future queued jobs, the oldest due job's age, running jobs and dead jobs in the last 24 hours, per lane."
      />
      <QueryState
        isPending={q.isPending}
        isError={q.isError}
        isEmpty={lanes.length === 0}
        emptyTitle="No lanes"
        onRetry={() => void q.refetch()}
      >
        <Table dense>
          <TableHead>
            <tr>
              <TableHeaderCell>Lane</TableHeaderCell>
              <TableHeaderCell>Queued (due)</TableHeaderCell>
              <TableHeaderCell>Oldest due</TableHeaderCell>
              <TableHeaderCell>Queued (future)</TableHeaderCell>
              <TableHeaderCell>Running</TableHeaderCell>
              <TableHeaderCell>Dead (24h)</TableHeaderCell>
            </tr>
          </TableHead>
          <TableBody>
            {lanes.map((l) => (
              <TableRow key={l.lane}>
                <TableCell>{l.lane}</TableCell>
                <TableCell>{l.queuedDue}</TableCell>
                <TableCell>{l.queuedDue > 0 ? fmtAge(l.oldestDueAgeS) : '—'}</TableCell>
                <TableCell>{l.queuedFuture}</TableCell>
                <TableCell>{l.running}</TableCell>
                <TableCell>{l.dead24h}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </QueryState>
    </section>
  );
}

export const section: WorkerSectionWeb = {
  key: 'queue',
  order: 60,
  label: 'Queue',
  perm: PERMS.WORKER_READ,
  Component: QueueSection,
};
